(function() {
  window.userService = {
    login(data) {
      return axios.post(`/api/user/login.php`, {email: data.email, password: data.password});
    },
    logout() {
      return axios.get(`/api/user/logout.php`);
    },
    get(data) {
      return axios.get(`/api/user/get.php?twitchId=${data ? data.userId : utils.cookies.get('user_id')}`);
    },
    create() {
      return axios.post('/api/user/create.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image')
      });
    },
    update() {
      return axios.post('/api/user/update.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image'),
        theme: utils.cookies.get('theme')
      })
    },
    getToken(data) {
      return axios.post('/api/token/get.php', {redirectUrl: data.redirectUrl, code: data.code});
    },
    refreshToken() {
      return axios.post('/api/token/validate.php', {});
    },
    search(data) {
      return axios.post('/api/user/search.php', {twitchDisplayName: data.twitchDisplayName});
    },
    stats() {
      return axios.get(`/api/user/stats.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    getCards(data) {
      return axios.get(`/api/user/card/get.php?twitchId=${data.twitchId}&unlockQueueId=${data.id}`);
    },
    getKeys() {
      return axios.get(`/api/user/key/get.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    getDogTags() {
      return axios.get(`/api/user/tags/get.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    saveCards(data) {
      return axios.post('/api/user/card/save.php', {
        twitchId: data.twitchId, 
        unlockQueueId: data.unlockQueueId, 
        cardId: data.cardId, 
        tier: data.tier
      });
    },
    unlockedCards() {
      return axios.get(`/api/user/card/unlocked.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    verifyCards(data) {
      let cards = data.cards
      cards = cards.join('-');
      cards = cards.replace(/#/g, '');
      return axios.get(`/api/user/card/verify.php?twitchId=${data.twitchId}&cards=${cards}`);
    },
    getLeaderboard() {
      return axios.get(`/api/leaderboard/get.php`);
    },
    getTeams(data) {
      return axios.get(`/api/user/team/get.php?twitchId=${utils.cookies.get('user_id')}`);
    },
    saveTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/save.php', data);
    },
    deleteTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/delete.php', data);
    },
    addMod(data) {
      return axios.post('/api/user/mod.php', data);
    }
  }
})();